var React = require('react');

function FullOrPartialIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48 24.8779C48.007 31.2917 45.4963 37.4521 41.0081 42.0338C36.5198 46.6156 30.4126 49.2527 24 49.3779L24 0.37793C30.4108 0.508789 36.5147 3.14769 41.0018 7.72822C45.4888 12.3088 48.0013 18.4658 48 24.8779Z","fill":"#F9F29D","key":0}),React.createElement("path",{"d":"M0 24.8779C-0.00698662 18.4641 2.50366 12.3038 6.99191 7.72205C11.4802 3.1403 17.5874 0.503173 24 0.37793L24 49.3779C17.5892 49.2471 11.4853 46.6082 6.99821 42.0276C2.51116 37.4471 -0.00133514 31.29 0 24.8779Z","fill":"#F2F2F2","key":1})]);
}

FullOrPartialIcon.defaultProps = {"width":"49","height":"50","viewBox":"0 0 49 50","fill":"none"};

module.exports = FullOrPartialIcon;

FullOrPartialIcon.default = FullOrPartialIcon;
